var rr = function rr(json) {
  var jsonString = JSON.stringify(json);
  var rrJsonString = jsonString.replace(/https:\/\/www.postman.com\//g, '/');
  return JSON.parse(rrJsonString);
};
module.exports = rr;